import React from "react";

import BasicContainer from "./BasicContainer";

interface CartTileProps {
  brandName: string;
  avatarUrl: string;
  productImages: string[];
  additionalCount: number;
  className?: string;
}

export default function CartTile({
  brandName,
  avatarUrl,
  productImages,
  additionalCount,
  className = "",
}: CartTileProps) {
  return (
    <BasicContainer className={className} style={{ padding: "16px" }}>
      <div className="mb-3 flex items-center gap-3">
        <img
          src={avatarUrl}
          alt={brandName}
          className="h-8 w-8 rounded-full object-cover"
        />
        <span className="text-fs-text-primary text-sm font-medium">
          {brandName}
        </span>
      </div>
      <div className="flex gap-2">
        {productImages.map((img, imgIndex) => (
          <img
            key={imgIndex}
            src={img}
            alt="Product"
            className="h-12 w-12 rounded-sm object-cover"
          />
        ))}
        <div className="flex h-12 w-12 items-center justify-center rounded-sm bg-(--slate-color-action-surface-inverse-hover)">
          <span className="text-fs-text-primary text-xs font-medium">
            +{additionalCount}
          </span>
        </div>
      </div>
    </BasicContainer>
  );
}
